<template>
  <div class="header">
    <div
      class="vacancy-box"
      :style="{ height: `${vacancyHeight}px` }"
      v-btnPermission="['Android', 'IOS']"
    ></div>
    <mt-header v-bind="$attrs" class="remind-head">
      <slot name="left" slot="left"></slot>

      <slot name="right" slot="right"></slot>
    </mt-header>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    vacancy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("app", ["phoneModel", "isHOM", "isAndroid", "isIOS"]),
    // 标题栏占位盒子高度
    vacancyHeight() {
      return this.isIOS ? 54 : 34;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fff;
}

.remind-head {
  width: 100vw;
}

.vacancy-box {
  width: 100vw;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/titleBar/index.vue